import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const SmluvyList = lazy(() =>
  import('@/modules/vozidla/SmlouvyList').then((m) => ({ default: m.SmluvyList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/smlouvy',
  component: () => (
    <Suspense fallback={null}>
      <SmluvyList />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
